import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "closeable"];
import { filterProps } from '../../../utils/filterProps';
import { DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE } from '../../constants';
import { Alert } from '../Alert';
import { jsx as _jsx } from "react/jsx-runtime";
export const FloatingAlert = _ref => {
  let {
      children,
      closeable = true
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps
  } = filterProps(rest);
  return /*#__PURE__*/_jsx(Alert, Object.assign({}, rest, domProps, {
    closeable: closeable,
    floating: true,
    [DATA_TRANSITIONAL_COMPONENT_ATTRIBUTE]: 'FloatingAlert',
    children: children
  }));
};
export default FloatingAlert;
FloatingAlert.displayName = 'FloatingAlert';